import { useEffect } from 'react';
import { supabase } from '@/shared/lib/supabase';

const INTERVAL_MS = 2 * 60 * 1000; // 2 min — igual que ManuJob

/**
 * Ping ligero a `participants.last_active_at` cada 2 min, SOLO si el tab
 * está visible. Sirve para métricas MAU/DAU sin telemetría externa —
 * un panel admin puede consultar `SELECT count(*) FROM participants
 * WHERE last_active_at > now() - interval '24 hours'`.
 *
 * Sin ping en:
 * - Tab en background (no gastar ancho de banda ni escrituras).
 * - Sin participantId (usuario no autenticado o profile aún cargando).
 * - Modo demo (RLS bloquearía el UPDATE de todos modos; skip para no gastar).
 *
 * Patrón heredado de ManuJob (`src/hooks/useUserMeta.js` líneas 55-63).
 * En ManuJob se hace sobre `user_meta`; aquí sobre `participants` porque
 * ManuSplit no tiene tabla separada de meta.
 */
export function useKeepAlive(participantId: string | undefined, isDemo: boolean): void {
  useEffect(() => {
    if (!participantId || isDemo) return;

    const ping = () => {
      if (document.visibilityState !== 'visible') return;
      void supabase
        .from('participants')
        .update({ last_active_at: new Date().toISOString() })
        .eq('id', participantId);
    };

    // Ping inicial al montar (útil para capturar visitas cortas < 2 min).
    ping();

    const interval = setInterval(ping, INTERVAL_MS);
    return () => clearInterval(interval);
  }, [participantId, isDemo]);
}
